<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-opacity duration-150"
      enter-from-class="opacity-0"
      leave-active-class="transition-opacity duration-100"
      leave-to-class="opacity-0">
      <div
        v-if="state.open"
        class="bg-scrim fixed inset-0 z-50 flex items-center justify-center p-6"
        role="presentation">
        <div
          ref="dialogRef"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="error-dialog-title"
          class="bg-surface dark:border-line w-full max-w-[400px] rounded-[18px] px-5 pt-[22px] pb-5 dark:border">
          <b
            id="error-dialog-title"
            class="mb-[7px] block text-[18px] font-semibold tracking-[-0.015em]">
            {{ state.title }}
          </b>
          <p class="text-muted mb-[18px] text-[15px] leading-[1.55]">{{ state.message }}</p>
          <AppButton
            v-if="state.retry"
            variant="hi"
            size="lg"
            block
            class="mb-2"
            @click="retry">
            {{ t("common.retry") }}
          </AppButton>
          <AppButton
            ref="closeRef"
            :variant="state.retry ? 'quiet' : 'hi'"
            size="lg"
            block
            @click="close">
            {{ t("common.close") }}
          </AppButton>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, onMounted, onUnmounted } from "vue"
import { useI18n } from "vue-i18n"
import { useErrorDialog } from "@/composables/useErrorDialog"
import AppButton from "./AppButton.vue"

const { t } = useI18n()
const { state, close, retry } = useErrorDialog()

const dialogRef = ref<HTMLElement | null>(null)

watch(
  () => state.open,
  async isOpen => {
    if (!isOpen) return
    await nextTick()
    dialogRef.value?.querySelector<HTMLButtonElement>("button")?.focus()
  }
)

function onKeydown(event: KeyboardEvent) {
  if (state.open && event.key === "Escape") close()
}

onMounted(() => document.addEventListener("keydown", onKeydown))
onUnmounted(() => document.removeEventListener("keydown", onKeydown))
</script>
